import { useAuthenticator } from '@aws-amplify/ui-react';
import { UserRole } from '../../constants/UserRole';

type RoleInfo = {
  role: UserRole;
  isAdmin: boolean;
  isSupport: boolean;
  isFleetAdmin: boolean;
  isFleetManager: boolean;
  isFleetViewer: boolean;
  isFleetUser: boolean;
  canAccessNotifications: boolean;
  canPlayVideoAudio: boolean;
  canDownloadVideo: boolean;
};

function useGetRole(): RoleInfo {
  const { user } = useAuthenticator((context) => [context.user]);
  const role = user.getSignInUserSession()
    ?.getAccessToken()
    ?.payload['cognito:groups']?.[0];

  return {
    role,
    isAdmin: role === UserRole.admin,
    isSupport: role === UserRole.support,
    isFleetAdmin: role === UserRole.fleetAdmin,
    isFleetManager: role === UserRole.fleetManager,
    isFleetViewer: role === UserRole.fleetViewer,
    isFleetUser: role === UserRole.fleetViewer || role === UserRole.fleetManager || role === UserRole.fleetAdmin,
    canAccessNotifications: role === UserRole.fleetManager || role === UserRole.fleetAdmin,
    canPlayVideoAudio: role !== UserRole.fleetManager && role !== UserRole.fleetViewer,
    canDownloadVideo: role !== UserRole.fleetManager && role !== UserRole.fleetViewer,
  };
}

export default useGetRole;
